import { Trigger } from '@kobalte/core/dialog';
import { IconPlayButton } from '@troon/icons/play-button';
import { Dialog, DialogContent } from '../overlays';
import { Picture } from '../components';

type Props = {
	code: string;
	poster: string;
};

export function VimeoVideo(props: Props) {
	return (
		<div class="relative aspect-video w-full overflow-hidden rounded-lg">
			<Dialog key="video">
				<Trigger
					as="button"
					class="size-full outline-none focus-visible:ring-2 focus-visible:ring-brand-100 focus-visible:ring-offset-2"
				>
					<Picture
						src={props.poster}
						class="relative z-0 aspect-[4/3] size-full"
						width={768}
						height={576}
						sizes="(min-width: 1024px) 60, (min-width: 768px) 75vw, 95vw"
						loading="lazy"
					/>
					<span class="absolute inset-0 flex items-center justify-center outline-none focus-visible:ring focus-visible:ring-brand-100 focus-visible:ring-offset-2 active:scale-95 motion-safe:transition-all motion-safe:duration-200">
						<IconPlayButton class="size-16 text-white" />
						<span class="sr-only">Play video</span>
					</span>
				</Trigger>
				<DialogContent width="fit" noPadding>
					<div class="aspect-video w-screen min-w-max px-4">
						<iframe
							class="aspect-video size-full rounded-xl"
							src={`https://player.vimeo.com/video/${props.code}?badge=0&autoplay=1&player_id=0&app_id=58479`}
							title="YouTube video player"
							allow="autoplay; fullscreen; picture-in-picture"
							allowfullscreen
						/>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
}
